import React, { useState, createContext } from "react";

export const PageContext = createContext({
    page: null,
    updatePage: (page) => {},
});

export const PageProvider = ({ children }) => {

    //const { PUBLIC_URL } = process.env;
    const [page, setPage] = useState({
        pageSlug: null,
        sectionSlug: null,
    });

    const contextValue = {
        page,
        updatePage: setPage
    };

    return ( <PageContext.Provider value = { contextValue } > { children } </PageContext.Provider>
    );
};